var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EcsEndpointSelectionDialogPresentation',{ref:"view",attrs:{"private-phones":_vm.privatePhones,"endpoint-current-type":_vm.endpointCurrentType,"endpoint-current-destination":_vm.endpointCurrentDestination,"endpoint-default-destination":_vm.endpointDefaultDestination},on:{"update-agent-endpoint":_vm.updateAgentEndpoint}})
}
var staticRenderFns = []

export { render, staticRenderFns }